/* eslint-disable no-empty-pattern */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  regions: [],
  deviceTypeId: [],
  menufacturerIds: [],

  overallSummaryData: {},
  m3ByPremiseGraph: [],
  m3PerformanceGraph: [],
  meterSystemAlarms: {},
  transmissionGraph: {},
};

export const overallSummarySlice = createSlice({
  name: "overallSummary",
  initialState,

  reducers: {
    SET_REGIONS: (state, { payload }) => {
      state.regions = payload;
    },
    SET_DEVICE_TYPE_ID: (state, { payload }) => {
      state.deviceTypeId = payload;
    },
    SET_MANUFACTURER_IDS: (state, { payload }) => {
      state.menufacturerIds = payload;
    },

    SET_OVERALL_SUMMARY_DATA: (state, { payload }) => {
      state.overallSummaryData = payload;
    },
    SET_M3_BY_PREMISE_GRAPH: (state, { payload }) => {
      state.m3ByPremiseGraph = payload;
    },
    SET_M3_PERFORMANCE_GRAPH: (state, { payload }) => {
      state.m3PerformanceGraph = payload;
    },
    SET_METER_SYSTEM_ALARMS: (state, { payload }) => {
      state.meterSystemAlarms = payload;
    },
    SET_TRANSMISSION_GRAPH: (state, { payload }) => {
      state.transmissionGraph = payload;
    },
  },
});

export const {
  SET_REGIONS,
  SET_DEVICE_TYPE_ID,
  SET_MANUFACTURER_IDS,
  SET_OVERALL_SUMMARY_DATA,

  SET_M3_BY_PREMISE_GRAPH,
  SET_M3_PERFORMANCE_GRAPH,
  SET_METER_SYSTEM_ALARMS,
  SET_TRANSMISSION_GRAPH,
} = overallSummarySlice.actions;

export default overallSummarySlice.reducer;
